import axios from 'axios'

export const companiesGmbAccounts = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
  },
  mutations: {
    readCompaniesGmbAccounts(state) {
      state.loading = true
      state.loadError = false
    },
    readCompaniesGmbAccountsSuccess(state, payload) {
      state.data = payload
      state.loading = false
    },
    readCompaniesGmbAccountsFailure(state) {
      state.loading = false
      state.loadError = true
    },
    deleteCompaniesGmbAccount(state) {
      state.loading = true
      state.loadError = false
    },
    deleteCompaniesGmbAccountSuccess(state) {
      state.loading = false
    },
    deleteCompaniesGmbAccountFailure(state) {
      state.loading = false
      state.loadError = true
    },
  },
  actions: {
    readCompaniesGmbAccounts({ commit }, companyUuid) {

      commit('readCompaniesGmbAccounts')
      return axios
        .get('/api/companies/'+ companyUuid +'/gmb/accounts.json')
        .then(res => {
          commit('readCompaniesGmbAccountsSuccess', res.data)
        })
        .catch(err => {
          commit('readCompaniesGmbAccountsFailure')
          // GMB未連携の場合に404エラーはFlash表示しない
          console.error(err)
        })
    },
    deleteCompaniesGmbAccount({ commit, state }, payload) {
      if (state.loading) return false

      commit('flash/clearFlash', null, { root: true })
      commit('deleteCompaniesGmbAccount')
      return axios
        .delete('/api/companies/'+ payload.companyUuid +'/gmb/accounts')
        .then(() => {
          commit('deleteCompaniesGmbAccountSuccess')
          commit('flash/updateFlash', { type: 'notice', message: 'Google マップのビジネスグループ連携を解除しました' }, { root: true })
          return true
        })
        .catch(err => {
          commit('deleteCompaniesGmbAccountFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
          return false
        })
    },
  }
}
